import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaskNotificationsViewStateMediatorService {
  private _taskNotificationListIsOpen = new BehaviorSubject<boolean>(false);
  private _taskNotificationsListElementIsHovered = new BehaviorSubject<boolean>(true);

  public taskNotificationsListIsOpen$ = this._taskNotificationListIsOpen.asObservable();
  public taskNotificationsListElementIsHovered$ = this._taskNotificationsListElementIsHovered.asObservable();

  public openTaskNotificationsList(): void {
    this._taskNotificationListIsOpen.next(true);
  }

  public closeTaskNotificationsList(): void {
    this._taskNotificationListIsOpen.next(false);
  }

  public toggleTaskNotificationsList(): void {
    this._taskNotificationListIsOpen.next(!this._taskNotificationListIsOpen.value);
  }

  public setTaskNotificationsListElementHovered(isHovered: boolean): void {
    this._taskNotificationsListElementIsHovered.next(isHovered);
  }

  public resetTaskNotificationsListElementHovered(): void {
    this._taskNotificationsListElementIsHovered.next(false);
  }
}